import request from '@/utils/request'

let hotKeyApi = {
  /*分类添加*/
  hotKeyAdd (data, errorback) {
    return request._post('/shop/product/hotkey/add', data, errorback)
  },

  hotKeyList (data, errorback) {
    return request._postBody('/shop/product/hotkey/list', data, errorback)
  },

  deleteHotKey (data, errorback) {
    return request._post('/shop/product/hotkey/delete', data, errorback)
  }
}
export default hotKeyApi



// WEBPACK FOOTER //
// ./src/api/hotkey.js